import { render, staticRenderFns } from "./UserMenuPopap.vue?vue&type=template&id=15a425a6&scoped=true"
import script from "./UserMenuPopap.vue?vue&type=script&lang=js"
export * from "./UserMenuPopap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a425a6",
  null
  
)

export default component.exports